import client, { noneAuthClient } from './client'
import { ListResponse, ApplicationInfo, SubscriptionInfo } from '@/types'

export const getApplications = () => {
  return client<ListResponse<ApplicationInfo>>({
    url: 'apps',
    method: 'get',
  })
}

export const getApplicationsByOrgId = (id: number) => {
  return client<{ apps: ApplicationInfo[] }>({
    url: `organizations/${id}/purchase/apps`,
    method: 'get',
    baseURL: '/api/v2/',
  }).then((res) => {
    if (res?.apps?.length) {
      res.apps.forEach((app) => {
        const url_prefix_arr = app.url_prefix.split('.')
        url_prefix_arr[0] = `${url_prefix_arr[0]}-${id}`
        app.url_prefix = url_prefix_arr.join('.')
      })
    }
    return res
  })
}

export const getAppCategories = () => {
  return client<{ data: string[] }>({
    url: 'apps/categories',
    method: 'get',
  })
}

export const getIntroApplications = () => {
  return noneAuthClient<ListResponse<ApplicationInfo>>({
    url: 'apps',
    method: 'get',
  })
}

export const subscribeApplication = (data: SubscriptionInfo, isAlert = true) => {
  return client<ListResponse<ApplicationInfo>>({
    url: `apps/${data.id}/subscribe`,
    method: 'post',
    data,
    isAlert,
  })
}

export const ensureSafelineCloud = (orgId: number) => {
  return client<unknown>({
    url: 'apps/safeline-cloud/ensure',
    method: 'post',
    data: { org_id: orgId },
    isAlert: false,
    redirectOnForbidden: false,
  })
}
